export default __webpack_public_path__ + "static/media/FamilyField.7a396bf9.jpg";